const request = {
    message_rate_limited: 'Foram enviadas demasiadas mensagens a este destinatário. Tente novamente mais tarde.',
    invalid_input: 'Input inválido. {{details}}',
    general: 'Ocorreu um erro no pedido.',
    range_not_satisfiable: 'Intervalo não satisfatório.',
    feature_not_supported: 'Esta funcionalidade não é suportada no ambiente atual.',
    rate_limited: 'Demasiados pedidos. Tente novamente mais tarde.',
};
export default Object.freeze(request);
